<template lang="pug">
  b-container.cellRow
    b-row(v-if="data_in")
      b-col().text-left.pl-0
        span.font-weight-bold(v-html="label")
      b-col()
        span(v-if="data_in") {{ data_in }}
        span(v-else) --
        span(v-html="unit").ml-1

</template>

<script>
export default {
  name: "tableCaseStudieRowSingle",
  props: ['label', 'data_in', 'data_out','unit']
}
</script>

<style scoped>

</style>